import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

export const SWIPER = {
  init: function () {
    const hero = document.querySelector('.js-swiper-hero')
    if (!hero) return

    /* eslint-disable no-unused-vars */
    const swiper = new Swiper('.js-swiper-hero .swiper', {
      loop: true,
      centeredSlides: true,
      initialSlide: 1,
      // loopedSlides: 6,
      slidesPerView: 'auto',
      centeredSlidesBounds: true,

      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        769: {
          // PC
          spaceBetween: 80,
          // slidesPerView: 1.6,
        },
        0: {
          // SP
          spaceBetween: 15,
          // slidesPerView: 1.100286532951289, // 384 / 349
        },
      },
    })
    window.addEventListener('resize', () => {
      swiper.update()
    })
    /* eslint-enable no-unused-vars */
  },
}
